package com.patronat.top.ui.organisms.venue

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.models.VenueModeratorOption
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.Black
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.LabelLarge
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.White

@Composable
fun VenueModeratorSelector(
    titlePrefix: String,
    selectedName: String,
    options: List<VenueModeratorOption>,
    expanded: Boolean,
    onExpandedChange: (Boolean) -> Unit,
    onOptionSelected: (VenueModeratorOption) -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    isLoading: Boolean = false,
    leadingIcon: Painter = AppIcons.VenueModeratorAssign
) {
    Box(modifier = modifier) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .height(48.dp)
                .clip(RoundedCornerShape(16.dp))
                .background(Primary100)
                .clickable(enabled = enabled) { onExpandedChange(!expanded) }
                .padding(horizontal = 16.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = leadingIcon,
                contentDescription = null,
                tint = Primary600,
                modifier = Modifier.size(20.dp)
            )

            Spacer(modifier = Modifier.width(8.dp))

            Text(
                text = "$titlePrefix $selectedName",
                style = LabelLarge,
                color = MineShaft900,
                modifier = Modifier.weight(1f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Spacer(modifier = Modifier.width(8.dp))

            if (isLoading) {
                CircularProgressIndicator(
                    modifier = Modifier.size(16.dp),
                    color = Primary600,
                    strokeWidth = 2.dp
                )
            } else {
                Icon(
                    painter = AppIcons.ArrowDown,
                    contentDescription = null,
                    tint = MineShaft900,
                    modifier = Modifier
                        .size(16.dp)
                        .rotate(if (expanded) 180f else 0f)
                )
            }
        }

        MaterialTheme(
            shapes = MaterialTheme.shapes.copy(extraSmall = RoundedCornerShape(12.dp))
        ) {
            DropdownMenu(
                expanded = expanded && options.isNotEmpty(),
                onDismissRequest = { onExpandedChange(false) },
                modifier = Modifier
                    .background(White)
                    .width(IntrinsicSize.Max)
                    .heightIn(max = 300.dp)
                    .padding(vertical = 4.dp),
                containerColor = White,
                tonalElevation = 0.dp,
                shadowElevation = 8.dp
            ) {
                options.forEach { option ->
                    DropdownMenuItem(
                        onClick = { onOptionSelected(option) },
                        contentPadding = PaddingValues(horizontal = 16.dp, vertical = 0.dp),
                        modifier = Modifier.height(34.dp),
                        text = {
                            Text(
                                text = option.fullName,
                                style = BodyMedium.copy(
                                    color = Black,
                                    fontSize = 12.sp,
                                    lineHeight = 18.sp
                                ),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    )
                }
            }
        }
    }
}
